import productCarousel from '../../jquery/lsag.productcarouselcomponent';

class RecentlyViewedService {
    /*@ngInject*/
    constructor($log, $http, $timeout, $rootScope, CommonService) {
        this.$log = $log;
        this.$http = $http;
        this.$timeout = $timeout;
        this.$rootScope = $rootScope;
        this.CommonService = CommonService;
        this.hasProducts = false;
    }

    requestRecentlyViewedProducts(productId, componentId) {
        this.$log.debug('Get recentlyViewedProducts for ' + productId);

        let url = this.CommonService.getBaseUrl() + '/ajax/lastSeenData?productCode=' + productId + '&componentUid=' + componentId;

        this.$http.get(url, null)
            .then((response) => {
                $('#lastseenproductcomponent .js-carousel-lazy').html(response.data);
                this.$timeout(() => {
                    if ($('#lastseenproductcomponent .js-carousel-lazy').find('.c-carousel__item').length) {
                        productCarousel.buildCarousel($('#lastseenproductcomponent .js-carousel-lazy'));
                        this.hasProducts = true;
                    }
                }, 1);

            }, (error) => {
                this.$log.error('productId: ' + productId + ', error in recentlyViewedProducts: ' + error.status + ' ' + error.statusText);
            });
    }

    hasRecentlyViewedProducts() {
        return this.hasProducts;
    }
}

export default RecentlyViewedService;
